const firebaseConfig = {
  apiKey: "AIzaSyDpbckctP7mNejXV-NGoCvh-RMAwinaMpk",
  authDomain: "watch-23b46.firebaseapp.com",
  projectId: "watch-23b46",
  storageBucket: "watch-23b46.appspot.com",
  messagingSenderId: "456051639538",
  appId: "1:456051639538:web:63ecd51bd65b27fb12fc6b",
  measurementId: "G-2KRP1SM1M8",
};

export default firebaseConfig;

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_APP_ID,
// };

// export default firebaseConfig;
